<div class="container">
  <form class="form" (ngSubmit)="onCrearComentarioSubmit()" [formGroup]="commentFormGroup">
    <div class="row">
      <div class="col-md-12">
        <mat-form-field class="full-width">
          <mat-label>Comentario</mat-label>
          <textarea matInput placeholder="Tarea necesaria..." formControlName="comment"></textarea>
        </mat-form-field>
      </div>
      <div class="col-md-12" style="display: flex; gap: 1rem;">
        <button class="full-width" mat-button type="button" (click)="onCancel()">
          Cancelar
        </button>
        <button class="full-width" [disabled]="!commentFormGroup.valid || fetchingComment" mat-flat-button
          type="submit">
          <div>
            @if (fetchingComment) {
            <mat-spinner diameter="20" color="warn"></mat-spinner>
            }@else{
            <p>Agregar</p>
            }
          </div>
        </button>
      </div>
    </div>
  </form>
  
  <app-table-selected-documents [documentsInformation]="documentsInformation"></app-table-selected-documents>
</div>
